import { List } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import { dateNameTimeFormat } from '../lib/utils';
import CustomDescriptionItem from './CustomDescriptionItem';

interface AuditCardProp {
  createdBy?: string;
  timeCreated?: string;
  updatedBy?: string;
  timeUpdated?: string;
}
const AuditCard: React.FC<AuditCardProp> = ({
  createdBy,
  updatedBy,
  timeCreated,
  timeUpdated,
}) => {
  return (
    <div className={'bg-white rounded w-full p-2'}>
      <List>
        <List.Item>
          <div>
            <CustomDescriptionItem label={'Prepared By'} content={createdBy} />
            <CustomDescriptionItem
              label={'Prepared Date'}
              content={dayjs(timeCreated).format(dateNameTimeFormat)}
            />
          </div>
        </List.Item>
        <List.Item>
          <div>
            <CustomDescriptionItem label={'Updated By'} content={updatedBy} />
            <CustomDescriptionItem
              label={'Updated Date'}
              content={dayjs(timeUpdated).format(dateNameTimeFormat)}
            />
          </div>
        </List.Item>
      </List>
    </div>
  );
};

export default AuditCard;
